/**
 * PULSE Product Form
 * ------------------------------------------------------------
 * Loaded from theme.liquid (persistent), NOT from inside the
 * section — script tags in swapped-in shell content never run.
 * init() is idempotent and re-runs after every shell navigation.
 */
(function(){

  function money(cents){
    var v = cents / 100;
    return '$' + (v % 1 === 0 ? v.toFixed(0) : v.toFixed(2));
  }

  function initProductForm(){
    var form = document.getElementById('ProductForm');
    if(!form || form.dataset.pulseInit === '1') return;

    var variantsEl = document.getElementById('ProductVariantsJson');
    if(!variantsEl) return;

    var variants = [];
    try{ variants = JSON.parse(variantsEl.textContent); }catch(e){ return; }

    var idInput = document.getElementById('ProductVariantId');
    var priceEl = document.getElementById('ProductPrice');
    var compareEl = document.getElementById('ProductComparePrice');
    var saveEl = document.getElementById('ProductSaveBadge');
    var anchorEl = document.querySelector('.product-price-anchor');
    var submitBtn = document.getElementById('ProductSubmit');
    var availabilityEl = document.getElementById('ProductAvailability');
    var picker = document.getElementById('VariantPicker');
    var mainImage = document.getElementById('ProductMainImage');
    if(!picker || !submitBtn) return;

    form.dataset.pulseInit = '1';

    function selectedOptionValues(){
      var values = [];
      picker.querySelectorAll('.variant-group').forEach(function(group){
        var sel = group.querySelector('.variant-pill.is-selected');
        values.push(sel ? sel.getAttribute('data-value') : null);
      });
      return values;
    }

    function findMatchingVariant(values){
      for(var i = 0; i < variants.length; i++){
        var v = variants[i];
        var opts = [v.option1, v.option2, v.option3];
        var match = true;
        for(var j = 0; j < values.length; j++){
          if(values[j] !== null && opts[j] !== values[j]){ match = false; break; }
        }
        if(match) return v;
      }
      return null;
    }

    function applyVariant(variant){
      if(!variant) return;
      idInput.value = variant.id;

      var priceText = money(variant.price);
      if(priceEl) priceEl.textContent = priceText;

      /* The Normatec comparison restates OUR price in its last
         <strong>. It is rendered server-side from the initial
         variant, so without this it keeps quoting the Long price
         after someone switches to Short — the headline price and
         the comparison line disagreed on the same screen. */
      if(anchorEl){
        var strongs = anchorEl.querySelectorAll('strong');
        if(strongs.length > 1){
          strongs[strongs.length - 1].textContent = priceText;
        }
      }

      var hasDeal = variant.compare_at_price && variant.compare_at_price > variant.price;

      if(compareEl){
        if(hasDeal){
          compareEl.textContent = money(variant.compare_at_price);
          compareEl.hidden = false;
        } else {
          compareEl.hidden = true;
        }
      }

      if(saveEl){
        if(hasDeal){
          var saved = variant.compare_at_price - variant.price;
          var pct = Math.round((saved / variant.compare_at_price) * 100);
          saveEl.textContent = 'Save ' + money(saved) + ' · ' + pct + '% off';
          saveEl.hidden = false;
        } else {
          saveEl.hidden = true;
        }
      }

      submitBtn.disabled = !variant.available;
      submitBtn.textContent = variant.available ? (submitBtn.dataset.label || 'Add to Bag') : 'Sold Out';

      if(availabilityEl){
        availabilityEl.textContent = variant.available
          ? (availabilityEl.dataset.label || 'In Stock')
          : 'Currently Unavailable';
        availabilityEl.classList.toggle('in-stock', variant.available);
      }

      if(mainImage && variant.featured_image && variant.featured_image.src){
        /* A variant swap must also clear srcset — otherwise the
           browser keeps resolving the responsive image from the
           OLD srcset candidates and ignores this new src entirely. */
        mainImage.removeAttribute('srcset');
        mainImage.removeAttribute('sizes');
        mainImage.src = variant.featured_image.src;
      }

      /* Variant title is what the sticky bar shows as the fit */
      var fit = '';
      if(variant.title && variant.title !== 'Default Title'){
        fit = variant.title;
      }

      window.dispatchEvent(new CustomEvent('pulse:variant-changed', {
        detail: {
          price: priceText,
          available: variant.available,
          fit: fit,
          id: variant.id
        }
      }));
    }

    submitBtn.dataset.label = submitBtn.textContent.trim();
    if(availabilityEl) availabilityEl.dataset.label = availabilityEl.textContent.trim();

    picker.addEventListener('click', function(e){
      var pill = e.target.closest('.variant-pill');
      if(!pill || pill.hasAttribute('disabled')) return;
      e.preventDefault();
      var group = pill.closest('.variant-group');
      group.querySelectorAll('.variant-pill').forEach(function(p){ p.classList.remove('is-selected'); });
      pill.classList.add('is-selected');
      applyVariant(findMatchingVariant(selectedOptionValues()));
    });

    document.querySelectorAll('.product-gallery-thumb').forEach(function(thumb){
      if(thumb.dataset.pulseInit === '1') return;
      thumb.dataset.pulseInit = '1';
      thumb.addEventListener('click', function(){
        document.querySelectorAll('.product-gallery-thumb').forEach(function(t){ t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
        if(mainImage){
          /* Same reason as the variant swap above: srcset must go,
             or the browser keeps rendering an old candidate and the
             thumbnail click appears to do nothing. */
          mainImage.removeAttribute('srcset');
          mainImage.removeAttribute('sizes');
          mainImage.src = thumb.getAttribute('data-full');
        }
      });
    });

    /* Announce the initial variant so dependent UI starts in sync */
    var initial = findMatchingVariant(selectedOptionValues());
    if(initial){
      var initFit = (initial.title && initial.title !== 'Default Title') ? initial.title : '';
      window.dispatchEvent(new CustomEvent('pulse:variant-changed', {
        detail: {
          price: money(initial.price),
          available: initial.available,
          fit: initFit,
          id: initial.id
        }
      }));
    }
  }

  function init(){ initProductForm(); }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  window.addEventListener('pulse:navigated', init);
})();
